import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { notificationPreferencesValidator } from "../notifications/preferences";
import { dashboardConfigValidator } from "../dashboard";

export const userRoles = v.union(
  v.literal("super_admin"),
  v.literal("company_admin"),
  v.literal("company_user"),
);

export const onboardingStepStatus = v.union(
  v.literal("pending"),
  v.literal("completed"),
  v.literal("skipped"),
);

export const onboardingProgress = v.object({
  completed: v.boolean(),
  currentStep: v.number(),
  steps: v.object({
    companySetup: onboardingStepStatus,
    businessType: onboardingStepStatus,
    currencyTimezone: onboardingStepStatus,
    moduleSelection: onboardingStepStatus,
  }),
  whatsapp: v.optional(v.string()),
  selectedModule: v.optional(v.string()),
  completedAt: v.optional(v.number()),
});

/**
 * Preferencias de idioma y región del usuario
 */
export const localePreferencesValidator = v.object({
  /** Idioma de la UI (es, en) */
  language: v.string(),
  /** Zona horaria (ej: America/Tegucigalpa) */
  timezone: v.optional(v.string()),
  /** Formato de fecha preferido */
  dateFormat: v.optional(v.string()),
  /** Primer día de la semana (0=domingo, 1=lunes) */
  firstDayOfWeek: v.optional(v.number()),
});

export const validatorUsers = v.object({
  // new fields (didn't exist in old version)
  name: v.optional(v.string()),
  image: v.optional(v.id("_storage")),
  email: v.string(),
  emailVerificationTime: v.optional(v.number()),
  phone: v.optional(v.string()),
  phoneVerificationTime: v.optional(v.number()),
  isAnonymous: v.optional(v.boolean()),
  isSuperAdmin: v.optional(v.boolean()),
  roleId: v.optional(v.id("roles")),
  branchIds: v.optional(v.array(v.id("branches"))),
  defaultBranchId: v.optional(v.id("branches")),
  activeBranchId: v.optional(v.id("branches")),
  dodoCustomerId: v.optional(v.string()),
  onboardingProgress: v.optional(onboardingProgress),
  notificationPreferences: v.optional(notificationPreferencesValidator),
  dashboardConfig: v.optional(dashboardConfigValidator),
  /** Preferencias de idioma y región */
  localePreferences: v.optional(localePreferencesValidator),

  internalControl: v.optional(internalControl),
});

export const users = defineTable(validatorUsers)
  .index("email", ["email"])
  .index("by_company_id_and_email", ["internalControl.companyId", "email"])
  .index("by_company_id_and_role_id", ["internalControl.companyId", "roleId"])
  .index("by_is_super_admin", ["isSuperAdmin"])
  .index("by_role_id", ["roleId"])
  .index("by_branch_ids", ["branchIds"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
